// File: src/index.js
import React, { StrictMode } from 'react'; // Removed Suspense, lazy
import ReactDOM from 'react-dom/client';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import ReactGA from 'react-ga4';
import { AuthContextProvider } from './AuthContext/AuthContext';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// Removed CircularProgress and Box imports as they were only for Suspense fallback

// Directly import all components instead of lazy loading them
import App from './App';
import Getinvolved from './components/GetInvolved/Getinvolved';
import Updates from './components/Updates/Updates';
import Chiefinvestigators from './components/ChiefInvestigators/ChiefInvestigator';
import Login from './components/Login/LoginForm';
import Publications from './components/Publications/Publications';
import MemberAccess from './components/MemberSection/MemberSection';
import MemberFAQ from './components/MemberAccordian/MemberFAQ';
import SignUp from './components/SignUp/Signup';
import PasswordReset from './components/PasswordReset/PasswordReset';

ReactGA.initialize('G-TNL0HZPW9P');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <StrictMode> {/* Changed React.StrictMode to StrictMode for clarity */}
      {/* Removed Suspense component and its fallback */}
      <AuthContextProvider>
        <Routes>
          <Route path="/memberaccess" element={
            <PrivateRoute>
              <MemberAccess />
            </PrivateRoute>
          } />
          <Route path="/things_to_know" element={
            <PrivateRoute>
              <MemberFAQ />
            </PrivateRoute>
          } />

          <Route path="/getinvolved" element={<Getinvolved />} />
          <Route path="/chiefinvestigators" element={<Chiefinvestigators />} />
          <Route path="/updates" element={<Updates />} />
          <Route path="/login" element={<Login />} />
          <Route path="/passwordreset" element={<PasswordReset />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/" element={<App />} />
        </Routes>
      </AuthContextProvider>
    </StrictMode>
  </Router>
);
